/* generated by scripts/goon-bags.js: do not edit */
window.GoonBags = {
 "generatedAt": "2026-11-05T04:01:37.677Z",
 "shopUrl": "https://afterdark.duskr.ca",
 "shippingAssumed": 12.95,
 "gift": {
  "handle": "fuckwater-sample-0-4oz-12ml-pillow-pack",
  "title": "FuckWater Sample",
  "variantId": "67927973822828",
  "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/88a39ac3-f5f5-4d3f-a573-f363266461c6.jpg?v=1793155534",
  "price": 6.95
 },
 "bags": [
  {
   "persona": "rideordie",
   "name": "Ride or Die",
   "variants": [
    {
     "id": "top",
     "label": "For the stroker",
     "when": null,
     "retail": 63.85,
     "price": 47.95,
     "savePct": 25,
     "savings": 15.9,
     "available": 13,
     "ok": true,
     "items": [
      {
       "handle": "premium-rolling-head-cup",
       "title": "Premium Rolling Head Cup",
       "cat": "stroker",
       "qty": 1,
       "price": 30.95,
       "variantId": "67619718070636",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/2e1c425a-17d2-4f60-bdcb-c879fac6365c.jpg?v=1790905052"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      },
      {
       "handle": "id-toy-cleaner-mist-1oz",
       "title": "ID Toy Cleaner Mist",
       "cat": "cleaner",
       "qty": 1,
       "price": 13.95,
       "variantId": "67928158634348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-01.jpg?v=1793155805"
      }
     ],
     "pro": {
      "retail": 115.75,
      "price": 81.95,
      "savePct": 29,
      "savings": 33.8,
      "available": 13,
      "ok": true,
      "items": [
       {
        "handle": "premium-rolling-head-cup",
        "title": "Premium Rolling Head Cup",
        "cat": "stroker",
        "qty": 1,
        "price": 30.95,
        "variantId": "67619718070636",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/2e1c425a-17d2-4f60-bdcb-c879fac6365c.jpg?v=1790905052"
       },
       {
        "handle": "uni-emerald",
        "title": "UNI EMERALD",
        "cat": "sleeve",
        "qty": 1,
        "price": 22.95,
        "variantId": "67619721412972",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/92692274-ffa6-4c92-b31e-e18d1eb03b60.png?v=1790905082"
       },
       {
        "handle": "stay-hard-silicone-dble-loop-lasso-black",
        "title": "Stay Hard Silicone Double Loop Lasso",
        "cat": "ring",
        "qty": 1,
        "price": 19.95,
        "variantId": "67927261151596",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       },
       {
        "handle": "id-toy-cleaner-mist-4oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 19.95,
        "variantId": "67928158667116",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-4.jpg?v=1793155807"
       }
      ]
     }
    },
    {
     "id": "bottom",
     "label": "For the bottom",
     "when": {
      "R": [
       "<=",
       0.38
      ]
     },
     "retail": 74.85,
     "price": 57.95,
     "savePct": 23,
     "savings": 16.9,
     "available": 42,
     "ok": true,
     "items": [
      {
       "handle": "peridise",
       "title": "PERIDISE",
       "cat": "prostate",
       "qty": 1,
       "price": 41.95,
       "variantId": "67619766305132",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/an3850.png?v=1790905476"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      },
      {
       "handle": "id-toy-cleaner-mist-1oz",
       "title": "ID Toy Cleaner Mist",
       "cat": "cleaner",
       "qty": 1,
       "price": 13.95,
       "variantId": "67928158634348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-01.jpg?v=1793155805"
      }
     ],
     "pro": {
      "retail": 157.8,
      "price": 125.95,
      "savePct": 20,
      "savings": 31.85,
      "available": 16,
      "ok": true,
      "items": [
       {
        "handle": "mgx-trident",
        "title": "MGX Trident",
        "cat": "prostate",
        "qty": 1,
        "price": 88.95,
        "variantId": "67619764142444",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/AN3701.jpg?v=1790905420"
       },
       {
        "handle": "cleanstream-enema-bulb-blue",
        "title": "CleanStream Enema Bulb Blue",
        "cat": "prep",
        "qty": 1,
        "price": 26.95,
        "variantId": "67929084821868",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/XRAB904.jpg?v=1793157157"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       },
       {
        "handle": "id-toy-cleaner-mist-4oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 19.95,
        "variantId": "67928158667116",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-4.jpg?v=1793155807"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "piston",
   "name": "The Piston",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 80.8,
     "price": 56.95,
     "savePct": 30,
     "savings": 23.85,
     "available": 20,
     "ok": true,
     "items": [
      {
       "handle": "original-vacuum-cup-extra-gentle",
       "title": "Original Vacuum Cup Extra Gentle",
       "cat": "stroker",
       "qty": 1,
       "price": 27.95,
       "variantId": "67619720954220",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/tn110-a_5366ad31-06b4-47d1-afbb-89ad3b54921e.png?v=1790905075"
      },
      {
       "handle": "stay-hard-silicone-dble-loop-lasso-black",
       "title": "Stay Hard Silicone Double Loop Lasso",
       "cat": "ring",
       "qty": 1,
       "price": 19.95,
       "variantId": "67927261151596",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      },
      {
       "handle": "id-toy-cleaner-mist-1oz",
       "title": "ID Toy Cleaner Mist",
       "cat": "cleaner",
       "qty": 1,
       "price": 13.95,
       "variantId": "67928158634348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-01.jpg?v=1793155805"
      }
     ],
     "pro": {
      "retail": 147.7,
      "price": 103.95,
      "savePct": 30,
      "savings": 43.75,
      "available": 13,
      "ok": true,
      "items": [
       {
        "handle": "premium-rolling-head-cup",
        "title": "Premium Rolling Head Cup",
        "cat": "stroker",
        "qty": 1,
        "price": 30.95,
        "variantId": "67619718070636",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/2e1c425a-17d2-4f60-bdcb-c879fac6365c.jpg?v=1790905052"
       },
       {
        "handle": "uni-diamond",
        "title": "UNI DIAMOND",
        "cat": "sleeve",
        "qty": 1,
        "price": 21.95,
        "variantId": "67619721609580",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/474b201d-c71e-469e-aa6b-0244f7b7a03e_538f7c70-f679-44e7-8d2d-131fa8267a26.png?v=1790905085"
       },
       {
        "handle": "stay-hard-silicone-dble-loop-lasso-black",
        "title": "Stay Hard Silicone Double Loop Lasso",
        "cat": "ring",
        "qty": 1,
        "price": 19.95,
        "variantId": "67927261151596",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
       },
       {
        "handle": "size-matters-beginners-pump",
        "title": "Size Matters",
        "cat": "pump",
        "qty": 1,
        "price": 32.95,
        "variantId": "67929084625260",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/xrab233-package.jpg?v=1793157155"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       },
       {
        "handle": "id-toy-cleaner-mist-4oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 19.95,
        "variantId": "67928158667116",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-4.jpg?v=1793155807"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "bottomless",
   "name": "Bottomless",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 81.8,
     "price": 57.95,
     "savePct": 29,
     "savings": 23.85,
     "available": 10,
     "ok": true,
     "items": [
      {
       "handle": "performance-prostimulator-vx1-black",
       "title": "Performance Prostimulator VX1- Black",
       "cat": "prostate",
       "qty": 1,
       "price": 21.95,
       "variantId": "67927277371756",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/40095.jpg?v=1793154488"
      },
      {
       "handle": "b-yours-basic-anal-plug-pink",
       "title": "B Yours Basic Anal Plug",
       "cat": "plug",
       "qty": 1,
       "price": 13.95,
       "variantId": "67927236772204",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/BL24110.jpg?v=1793154425"
      },
      {
       "handle": "cleanstream-enema-bulb-blue",
       "title": "CleanStream Enema Bulb Blue",
       "cat": "prep",
       "qty": 1,
       "price": 26.95,
       "variantId": "67929084821868",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/XRAB904.jpg?v=1793157157"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      }
     ],
     "pro": {
      "retail": 189.75,
      "price": 145.95,
      "savePct": 23,
      "savings": 43.8,
      "available": 8,
      "ok": true,
      "items": [
       {
        "handle": "mgx-trident",
        "title": "MGX Trident",
        "cat": "prostate",
        "qty": 1,
        "price": 88.95,
        "variantId": "67619764142444",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/AN3701.jpg?v=1790905420"
       },
       {
        "handle": "temptasia-bling-plug-large-black",
        "title": "Temptasia Bling Plug Large",
        "cat": "plug",
        "qty": 1,
        "price": 25.95,
        "variantId": "67927794549100",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/BL95855-1.jpg?v=1793155277"
       },
       {
        "handle": "cleanstream-deluxe-enema-bulb",
        "title": "Cleanstream Deluxe Enema Bulb",
        "cat": "prep",
        "qty": 1,
        "price": 32.95,
        "variantId": "67929119064428",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/XRAD914-1.jpg?v=1793157209"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       },
       {
        "handle": "id-toy-cleaner-mist-4oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 19.95,
        "variantId": "67928158667116",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-4.jpg?v=1793155807"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "switch",
   "name": "Switch Hitter",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 85.8,
     "price": 60.95,
     "savePct": 29,
     "savings": 24.85,
     "available": 18,
     "ok": true,
     "items": [
      {
       "handle": "sd-original-vacuum-cup-gentle",
       "title": "SD Original Vacuum Cup Gentle",
       "cat": "stroker",
       "qty": 1,
       "price": 24.95,
       "variantId": "67619718431084",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/tn819-a_4b68ec3d-5440-4bf8-9071-ef36775c8c0e.png?v=1790905055"
      },
      {
       "handle": "performance-prostimulator-vx1-black",
       "title": "Performance Prostimulator VX1- Black",
       "cat": "prostate",
       "qty": 1,
       "price": 21.95,
       "variantId": "67927277371756",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/40095.jpg?v=1793154488"
      },
      {
       "handle": "stay-hard-silicone-dble-loop-lasso-black",
       "title": "Stay Hard Silicone Double Loop Lasso",
       "cat": "ring",
       "qty": 1,
       "price": 19.95,
       "variantId": "67927261151596",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      }
     ],
     "pro": {
      "retail": 134.75,
      "price": 94.95,
      "savePct": 30,
      "savings": 39.8,
      "available": 13,
      "ok": true,
      "items": [
       {
        "handle": "premium-rolling-head-cup",
        "title": "Premium Rolling Head Cup",
        "cat": "stroker",
        "qty": 1,
        "price": 30.95,
        "variantId": "67619718070636",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/2e1c425a-17d2-4f60-bdcb-c879fac6365c.jpg?v=1790905052"
       },
       {
        "handle": "peridise",
        "title": "PERIDISE",
        "cat": "prostate",
        "qty": 1,
        "price": 41.95,
        "variantId": "67619766305132",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/an3850.png?v=1790905476"
       },
       {
        "handle": "stay-hard-silicone-dble-loop-lasso-black",
        "title": "Stay Hard Silicone Double Loop Lasso",
        "cat": "ring",
        "qty": 1,
        "price": 19.95,
        "variantId": "67927261151596",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       },
       {
        "handle": "id-toy-cleaner-mist-4oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 19.95,
        "variantId": "67928158667116",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-4.jpg?v=1793155807"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "warden",
   "name": "The Warden",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 78.8,
     "price": 55.95,
     "savePct": 29,
     "savings": 22.85,
     "available": 12,
     "ok": true,
     "items": [
      {
       "handle": "beginners-handcuffs",
       "title": "Beginner's Handcuffs",
       "cat": "restraint",
       "qty": 1,
       "price": 23.95,
       "variantId": "67919045656940",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0285-a.png?v=1793118715"
      },
      {
       "handle": "mahogany-flogger",
       "title": "Mahogany Flogger",
       "cat": "impact",
       "qty": 1,
       "price": 20.95,
       "variantId": "67919044706668",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0438-a.png?v=1793118705"
      },
      {
       "handle": "sex-wrap-tease-tape-100-black",
       "title": "Sex Wrap Tease Tape 100'",
       "cat": "rope",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927998333292",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/hp2751-1.jpg?v=1793155576"
      },
      {
       "handle": "satin-blindfold-black",
       "title": "Satin Blindfold Black",
       "cat": "blindfold",
       "qty": 1,
       "price": 14.95,
       "variantId": "67919044870508",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0018bk-a.png?v=1793118707"
      }
     ],
     "pro": {
      "retail": 148.7,
      "price": 104.95,
      "savePct": 29,
      "savings": 43.75,
      "available": 11,
      "ok": true,
      "items": [
       {
        "handle": "sports-cuffs-black",
        "title": "Sports Cuffs",
        "cat": "restraint",
        "qty": 1,
        "price": 35.95,
        "variantId": "67919059157356",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0019-a.png?v=1793118934"
       },
       {
        "handle": "leather-paddle-w-black-fur-side",
        "title": "Leather Paddle w/ Black Fur Side",
        "cat": "impact",
        "qty": 1,
        "price": 31.95,
        "variantId": "67919059386732",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0234-a.png?v=1793118936"
       },
       {
        "handle": "sex-wrap-tease-tape-100-black",
        "title": "Sex Wrap Tease Tape 100'",
        "cat": "rope",
        "qty": 1,
        "price": 18.95,
        "variantId": "67927998333292",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/hp2751-1.jpg?v=1793155576"
       },
       {
        "handle": "satin-blindfold-black",
        "title": "Satin Blindfold Black",
        "cat": "blindfold",
        "qty": 1,
        "price": 14.95,
        "variantId": "67919044870508",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0018bk-a.png?v=1793118707"
       },
       {
        "handle": "chained-nipple-clamps",
        "title": "Chained Nipple Clamps",
        "cat": "clamps",
        "qty": 1,
        "price": 20.95,
        "variantId": "67919045034348",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0896-a.png?v=1793118709"
       },
       {
        "handle": "brat-ball-gag",
        "title": "Brat Ball Gag",
        "cat": "gag",
        "qty": 1,
        "price": 25.95,
        "variantId": "67919051522412",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp8421-a.png?v=1793118763"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "yessir",
   "name": "Yes, Sir",
   "variants": [
    {
     "id": "classic",
     "label": null,
     "when": null,
     "retail": 81.8,
     "price": 57.95,
     "savePct": 29,
     "savings": 23.85,
     "available": 11,
     "ok": true,
     "items": [
      {
       "handle": "beginners-handcuffs",
       "title": "Beginner's Handcuffs",
       "cat": "restraint",
       "qty": 1,
       "price": 23.95,
       "variantId": "67919045656940",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0285-a.png?v=1793118715"
      },
      {
       "handle": "satin-blindfold-black",
       "title": "Satin Blindfold Black",
       "cat": "blindfold",
       "qty": 1,
       "price": 14.95,
       "variantId": "67919044870508",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0018bk-a.png?v=1793118707"
      },
      {
       "handle": "solid-red-ball-gag",
       "title": "Solid Red Ball Gag",
       "cat": "gag",
       "qty": 1,
       "price": 21.95,
       "variantId": "67919049032044",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0247-a.png?v=1793118747"
      },
      {
       "handle": "chained-nipple-clamps",
       "title": "Chained Nipple Clamps",
       "cat": "clamps",
       "qty": 1,
       "price": 20.95,
       "variantId": "67919045034348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0896-a.png?v=1793118709"
      }
     ],
     "pro": {
      "retail": 159.7,
      "price": 111.95,
      "savePct": 30,
      "savings": 47.75,
      "available": 7,
      "ok": true,
      "items": [
       {
        "handle": "sports-cuffs-black",
        "title": "Sports Cuffs",
        "cat": "restraint",
        "qty": 1,
        "price": 35.95,
        "variantId": "67919059157356",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0019-a.png?v=1793118934"
       },
       {
        "handle": "satin-blindfold-black",
        "title": "Satin Blindfold Black",
        "cat": "blindfold",
        "qty": 1,
        "price": 14.95,
        "variantId": "67919044870508",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0018bk-a.png?v=1793118707"
       },
       {
        "handle": "brat-ball-gag",
        "title": "Brat Ball Gag",
        "cat": "gag",
        "qty": 1,
        "price": 25.95,
        "variantId": "67919051522412",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp8421-a.png?v=1793118763"
       },
       {
        "handle": "chained-nipple-clamps",
        "title": "Chained Nipple Clamps",
        "cat": "clamps",
        "qty": 1,
        "price": 20.95,
        "variantId": "67919045034348",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0896-a.png?v=1793118709"
       },
       {
        "handle": "riding-crop",
        "title": "Riding Crop",
        "cat": "impact",
        "qty": 1,
        "price": 19.95,
        "variantId": "67919046082924",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0797-a.png?v=1793118722"
       },
       {
        "handle": "strict-zip-front-bondage-black-hood",
        "title": "Strict Zip Front Bondage Black Hood",
        "cat": "hood",
        "qty": 1,
        "price": 41.95,
        "variantId": "67930769260908",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/XRAG697.jpg?v=1793157901"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "allyoucaneat",
   "name": "All You Can Eat",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 95.75,
     "price": 67.95,
     "savePct": 29,
     "savings": 27.8,
     "available": 10,
     "ok": true,
     "items": [
      {
       "handle": "egg-cone",
       "title": "EGG CONE",
       "cat": "egg",
       "qty": 1,
       "price": 21.95,
       "variantId": "67619720364396",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/egg-h04-a.jpg?v=1790905067"
      },
      {
       "handle": "stay-hard-silicone-dble-loop-lasso-black",
       "title": "Stay Hard Silicone Double Loop Lasso",
       "cat": "ring",
       "qty": 1,
       "price": 19.95,
       "variantId": "67927261151596",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/32095.jpg?v=1793154460"
      },
      {
       "handle": "b-yours-basic-anal-plug-pink",
       "title": "B Yours Basic Anal Plug",
       "cat": "plug",
       "qty": 1,
       "price": 13.95,
       "variantId": "67927236772204",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/BL24110.jpg?v=1793154425"
      },
      {
       "handle": "chained-nipple-clamps",
       "title": "Chained Nipple Clamps",
       "cat": "clamps",
       "qty": 1,
       "price": 20.95,
       "variantId": "67919045034348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0896-a.png?v=1793118709"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      }
     ],
     "pro": {
      "retail": 156.65,
      "price": 109.95,
      "savePct": 30,
      "savings": 46.7,
      "available": 6,
      "ok": true,
      "items": [
       {
        "handle": "egg-misty-ii",
        "title": "Egg Misty II",
        "cat": "egg",
        "qty": 1,
        "price": 23.95,
        "variantId": "67619720593772",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/egg-h05-a.jpg?v=1790905070"
       },
       {
        "handle": "double-play-dual-vibrating-ring",
        "title": "Double Play Dual Vibrating Ring",
        "cat": "ring",
        "qty": 1,
        "price": 25.95,
        "variantId": "67927745626476",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/77101.jpg?v=1793155201"
       },
       {
        "handle": "luxe-wearable-vibra-slim-plug-sm-purple",
        "title": "Luxe Wearable Vibra Slim Plug Small",
        "cat": "plug",
        "qty": 1,
        "price": 28.95,
        "variantId": "67926648455532",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/bl11851-1.jpg?v=1793154071"
       },
       {
        "handle": "chained-nipple-clamps",
        "title": "Chained Nipple Clamps",
        "cat": "clamps",
        "qty": 1,
        "price": 20.95,
        "variantId": "67919045034348",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0896-a.png?v=1793118709"
       },
       {
        "handle": "satin-blindfold-black",
        "title": "Satin Blindfold Black",
        "cat": "blindfold",
        "qty": 1,
        "price": 14.95,
        "variantId": "67919044870508",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0018bk-a.png?v=1793118707"
       },
       {
        "handle": "riding-crop",
        "title": "Riding Crop",
        "cat": "impact",
        "qty": 1,
        "price": 19.95,
        "variantId": "67919046082924",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/sp0797-a.png?v=1793118722"
       },
       {
        "handle": "fuckwater-original-8-oz",
        "title": "FuckWater Original 8 oz",
        "cat": "lube",
        "qty": 1,
        "price": 21.95,
        "variantId": "67927958028652",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "jerkcircle",
   "name": "Jerk Circle",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 73.8,
     "price": 51.95,
     "savePct": 30,
     "savings": 21.85,
     "available": 44,
     "ok": true,
     "items": [
      {
       "handle": "egg-cone",
       "title": "EGG CONE",
       "cat": "egg",
       "qty": 1,
       "price": 21.95,
       "variantId": "67619720364396",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/egg-h04-a.jpg?v=1790905067"
      },
      {
       "handle": "stay-hard-donut-c-ring-tricolor",
       "title": "Stay Hard Donut C Ring- Tricolor",
       "cat": "ring",
       "qty": 1,
       "price": 10.95,
       "variantId": "67926617588076",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/00899.jpg?v=1793154025"
      },
      {
       "handle": "whose-dare-will-you-do-game",
       "title": "Whose Dare Will You Do? Game",
       "cat": "game",
       "qty": 1,
       "price": 18.95,
       "variantId": "67928166367596",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/KGBG.A10.jpg?v=1793155819"
      },
      {
       "handle": "fuckwater-original-8-oz",
       "title": "FuckWater Original 8 oz",
       "cat": "lube",
       "qty": 1,
       "price": 21.95,
       "variantId": "67927958028652",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW8.jpg?v=1793155521"
      }
     ],
     "pro": {
      "retail": 128.7,
      "price": 90.95,
      "savePct": 29,
      "savings": 37.75,
      "available": 6,
      "ok": true,
      "items": [
       {
        "handle": "egg-misty-ii",
        "title": "Egg Misty II",
        "cat": "egg",
        "qty": 1,
        "price": 23.95,
        "variantId": "67619720593772",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/egg-h05-a.jpg?v=1790905070"
       },
       {
        "handle": "the-player-vibrating-double-c-ring",
        "title": "The Player Vibrating Double C-ring",
        "cat": "ring",
        "qty": 1,
        "price": 20.95,
        "variantId": "67927786357100",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/91911.jpg?v=1793155266"
       },
       {
        "handle": "gay-card-sex-game",
        "title": "Gay Card Sex Game",
        "cat": "game",
        "qty": 1,
        "price": 14.95,
        "variantId": "67928174100844",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/KGBG.C42.jpg?v=1793155834"
       },
       {
        "handle": "pocket-tenga-wavy-line",
        "title": "Pocket Tenga Wavy Line",
        "cat": "stroker",
        "qty": 1,
        "price": 19.95,
        "variantId": "67619717316972",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/pot-0011000x1000_1000x1000_9f02d81c-5ac3-46fc-b379-ec5623558803.png?v=1790905046"
       },
       {
        "handle": "uni-topaz",
        "title": "UNI TOPAZ",
        "cat": "sleeve",
        "qty": 1,
        "price": 22.95,
        "variantId": "67619721806188",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/b7f325d3-5ba7-43f2-9710-4cdf5d190f41.png?v=1790905088"
       },
       {
        "handle": "fuckwater-original-16-oz",
        "title": "FuckWater Original 16 oz",
        "cat": "lube",
        "qty": 1,
        "price": 25.95,
        "variantId": "67927957537132",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW16.jpg?v=1793155513"
       }
      ]
     }
    }
   ]
  },
  {
   "persona": "lookatme",
   "name": "Look At Me",
   "variants": [
    {
     "id": "default",
     "label": null,
     "when": null,
     "retail": 81.8,
     "price": 57.95,
     "savePct": 29,
     "savings": 23.85,
     "available": 11,
     "ok": true,
     "items": [
      {
       "handle": "performance-silicone-glo-cring-blue-glow",
       "title": "Performance Silicone Glow C-Ring",
       "cat": "glow",
       "qty": 1,
       "price": 20.95,
       "variantId": "67927778001260",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/91167.jpg?v=1793155250"
      },
      {
       "handle": "firefly-prince-sm-gid-silic-plug-purp",
       "title": "Firefly Prince Small GID Silicone Plug",
       "cat": "plug",
       "qty": 1,
       "price": 20.95,
       "variantId": "67928327618924",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/NSN-0476-15_firefly-prince-sm-purple-bulk_lo.jpg?v=1793156075"
      },
      {
       "handle": "spank-me-x-pasties-black-w-pink",
       "title": "Spank Me x + Pasties",
       "cat": "pasties",
       "qty": 1,
       "price": 20.95,
       "variantId": "67928478122348",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/PTPLS-SME.jpg?v=1793156300"
      },
      {
       "handle": "fuckwater-original-4-oz",
       "title": "FuckWater Original 4 oz",
       "cat": "lube",
       "qty": 1,
       "price": 18.95,
       "variantId": "67927957635436",
       "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
      }
     ],
     "pro": {
      "retail": 137.7,
      "price": 96.95,
      "savePct": 30,
      "savings": 40.75,
      "available": 8,
      "ok": true,
      "items": [
       {
        "handle": "performance-silicone-glo-cring-blue-glow",
        "title": "Performance Silicone Glow C-Ring",
        "cat": "glow",
        "qty": 1,
        "price": 20.95,
        "variantId": "67927778001260",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/91167.jpg?v=1793155250"
       },
       {
        "handle": "firefly-prince-sm-gid-silic-plug-purp",
        "title": "Firefly Prince Small GID Silicone Plug",
        "cat": "plug",
        "qty": 1,
        "price": 20.95,
        "variantId": "67928327618924",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/NSN-0476-15_firefly-prince-sm-purple-bulk_lo.jpg?v=1793156075"
       },
       {
        "handle": "strict-male-body-harness",
        "title": "STRICT Male Body Harness",
        "cat": "harness",
        "qty": 1,
        "price": 41.95,
        "variantId": "67930770473324",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/XRAF249a.jpg?v=1793157913"
       },
       {
        "handle": "spank-me-x-pasties-black-w-pink",
        "title": "Spank Me x + Pasties",
        "cat": "pasties",
        "qty": 1,
        "price": 20.95,
        "variantId": "67928478122348",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/PTPLS-SME.jpg?v=1793156300"
       },
       {
        "handle": "fuckwater-original-4-oz",
        "title": "FuckWater Original 4 oz",
        "cat": "lube",
        "qty": 1,
        "price": 18.95,
        "variantId": "67927957635436",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/FW4.jpg?v=1793155519"
       },
       {
        "handle": "id-toy-cleaner-mist-1oz",
        "title": "ID Toy Cleaner Mist",
        "cat": "cleaner",
        "qty": 1,
        "price": 13.95,
        "variantId": "67928158634348",
        "image": "https://cdn.shopify.com/s/files/1/1019/6212/1580/files/IDTC-01.jpg?v=1793155805"
       }
      ]
     }
    }
   ]
  }
 ]
};
